import { assertNever } from '@deltasierra/shared';
import { DefaultTheme, useTheme } from 'styled-components';

export enum DSColour {
    primary = 'primary',
    secondary = 'secondary',
    red = 'red',
    yellow = 'yellow',
    green = 'green',
}

export function getDSColour(colour: DSColour, theme: DefaultTheme): string {
    switch (colour) {
        case DSColour.primary:
            return theme.palette.primary.main;
        case DSColour.secondary:
            return theme.palette.secondary.main;
        case DSColour.red:
            return '#FF4F4D';
        case DSColour.yellow:
            return '#F5CF47';
        case DSColour.green:
            return '#08696B';
        default:
            return assertNever(colour);
    }
}

export function getRandomDSColour(offset?: number): DSColour {
    const dsColourKeys = Object.keys(DSColour);
    const index = offset ?? Math.floor(Math.random() * dsColourKeys.length);
    return (DSColour as any)[Object.keys(DSColour)[index % dsColourKeys.length]];
}

export function useDSColour(colour: DSColour): string {
    const theme = useTheme();
    return getDSColour(colour, theme);
}
